import OrderSettings from './OrderSettings.view';

export default OrderSettings;
